import angular from 'angular';
import moment from 'moment';
import template from "./p360ViewManager.html";

export function p360ViewManagerDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: p360ViewManagerController,
    controllerAs: 'p360ViewManager',
    bindToController: true
  };
}

class p360ViewManagerController {
  constructor($location, $routeParams, $scope, $translate, $q, $interval, Notes, ConnectionQuality, API, Auth, Clients, DownloadFile, Stats, $rootScope) {
    'ngInject';

    window.scrollTo(0,0); // when from profitabily view scroll should always be on top

    this.state = "loading";

    this.$location = $location;
    this.$scope = $scope;
    this.$q = $q;
    this.$translate = $translate;
    this.API = API;
    this.Auth = Auth;
    this.Clients = Clients;
    this.DownloadFile = DownloadFile;
    this.Stats = Stats;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.clientId = decodeURIComponent($routeParams.clientId);
    this.type = $routeParams.type;
    this.hasId = !!(this.clientId && this.type);
    this.allTeams = $routeParams.allTeams;
    this.currencyFromParam = $routeParams.currency;
    this.initialClientNameFromParam = $routeParams.clientId ? $routeParams.clientId : null;
    const maybeTeamIds = !this.allTeams && localStorage.getItem('roedl-m-teams-pv');
    if (this.hasId && maybeTeamIds) {
      $rootScope.subTeamsScope = maybeTeamIds.split(",");
    }
    this.selectedClients = [];
    this.selectedGroups = [];
    this.selectedTeams = {};
    this.selectedTeamsSelected = [];
    this.shareDlgVisible = false;
    this.shareDlgData = null;
    this.monthlyIncomes = null;
    this.currencies = null;

    this.$rootScope = $rootScope;

    //share modal
    this.showModal = false;

    this.shareLink = '';
    this.selectedProcessGroup = '';
    this.currencyRatio = 1;
    this.isManager = this.$location.path().startsWith('/stats/management/360-view');
    this.isLeader = this.$location.path().startsWith('/stats/team/360-view');
    this.leaderTeamId = null;

    if ($routeParams.from && $routeParams.to) {
      localStorage.setItem(
        this.isLeader
          ? 'roedl-tl-date-pv'
          : 'roedl-m-date-pv'
        , $routeParams.from + '-' + $routeParams.to
      );
    }

    const storedDate = this.isLeader
      ? localStorage.getItem('roedl-tl-date-pv')
      : localStorage.getItem('roedl-m-date-pv');

    //currency modal
    this.currencyModalHidden = true;
    this.setupDate = this.$rootScope.setupDate ? moment().format("YYYY-MM-DD") : this.$rootScope.setupDate;
    this.localToEurRatio = '';
    
    this.$scope.$watch(() => this.currencyRatio, () => this.setupCurrencyRate());

    if (storedDate) {
      let date = storedDate.split("-"); //2018-07-2018-12 -> ['2018','07','2018','12']
      this.dateStartYear = date[0];
      this.dateStartMonth = date[1];
      this.dateEndYear = date[2];
      this.dateEndMonth = date[3];
    } else {
      this.dateEndYear = moment().subtract(1, "month").format("YYYY");
      this.dateEndMonth = moment().subtract(1, "month").format("MM");

      const monthDiff = this.hasId ? 6 : 1;
      this.dateStartYear = moment().subtract(monthDiff, "month").format("YYYY");
      this.dateStartMonth = moment().subtract(monthDiff, "month").format("MM");
    }

    this.selectedDates = [this.dateStartMonth, this.dateStartYear,  this.dateEndMonth, this.dateEndYear];
    this.updateDateRangeTrigger = (fromMonth, fromYear, toMonth, toYear) => {
      this.dateStartMonth = fromMonth;
      this.dateStartYear = fromYear;
      this.dateEndMonth = toMonth;
      this.dateEndYear = toYear;
      this.updateDateRange(true);
    };

    this.updateDateRange();
    this.Auth.authorize().then(user => {
        this.user = user;
        this.leaderTeamId = this.isLeader ? this.user.teamId : null;
        this.isLeader = !!this.leaderTeamId;
        this.Auth.getCustomSetupExchangeRate().then(customSetupExchangeRate =>{
          this.$rootScope.setupRate = customSetupExchangeRate.data;
          this.refresh360View();
        });

      },
      () => {
        this.Auth.handleUnauthorized();
        this.state = "error";
      });

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  buttonRangeChange(monthSpan) {
    this.changeDateRange(monthSpan, true);
  }

  changeDateRange(monthSpan, refresh) {
    const newStartDate = this.endDate.subtract(monthSpan - 1, "month");

    this.dateStartYear = newStartDate.year() < 2016 ? "2016" : newStartDate.format("YYYY");
    this.dateStartMonth = newStartDate.year() < 2016 ? "01" : newStartDate.format("MM");
    this.updateDateRange(refresh);
  }

  openShareModal(){
    this.showModal = true;
  }

  closeShareModal(){
    this.showModal = false;
  }

  processGroupSheet(legendToggleGroupChart, filteredApiDataPg) {
    if (legendToggleGroupChart === 'All') {
      return {
        exportScope: {
          value: 'All',
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: filteredApiDataPg.filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S'))),
        chartMetadata: {
          chartType: "ProcessGroups",
          allowedColumns: ['ProcessGroup', 'ProcessName', 'NvaDuration', 'VaDuration']
        }
      };
    }
    if (legendToggleGroupChart === 'Nva') {
      return {
        exportScope: {
          value: 'Nva',
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: filteredApiDataPg.map((x) => {
            return {...x, vaDuration: 'PT0S'};
        }).filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S'))),
        chartMetadata: {
          chartType: "ProcessGroups",
          allowedColumns: ['ProcessGroup', 'ProcessName', 'NvaDuration']
        }
      };
    }
    if (legendToggleGroupChart === 'Va') {
      return {
        exportScope: {
          value: 'Va',
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: filteredApiDataPg.map((x) => {
          return {...x, nvaDuration: 'PT0S'};
        }).filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S'))),
        chartMetadata: {
          chartType: "ProcessGroups",
          allowedColumns: ['ProcessGroup', 'ProcessName', 'VaDuration']
        }
      };
    }
    return null;
  }

  vaProcessesSheet(filteredApiDataPg, selectedProcessGroup) {
    return {
      exportScope: {
        value: 'Va',
        processGroup: selectedProcessGroup || null,
        processName: null,
        seniorityLevels: null,
        processProblems: null
      },
      data: filteredApiDataPg.map((x) => {
        return {...x, nvaDuration: 'PT0S'};
      }).filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S')))
      .filter((x) => !selectedProcessGroup || !x.processGroupName || x.processGroupName == selectedProcessGroup),
      chartMetadata: {
        chartType: "VaProcesses",
        allowedColumns: ['ProcessGroup', 'ProcessName', 'VaDuration']
      }
    };
  }

  nvaProcessesSheet(filteredApiDataPg, selectedProcessGroup) {
    return {
      exportScope: {
        value: 'Nva',
        processGroup: selectedProcessGroup || null,
        processName: null,
        seniorityLevels: null,
        processProblems: null
      },
      data: filteredApiDataPg.map((x) => {
        return {...x, vaDuration: 'PT0S'};
      }).filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S')))
      .filter((x) => !selectedProcessGroup || !x.processGroupName || x.processGroupName == selectedProcessGroup),
      chartMetadata: {
        chartType: "NvaProcesses",
        allowedColumns: ['ProcessGroup', 'ProcessName', 'NvaDuration']
      }
    };
  }

  profitabilitySheet(filteredApiDataProfitability) {
      return {
        exportScope: {
          value: 'All',
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: filteredApiDataProfitability.map((x) => {
          return {...x, effectiveRate: x.effectiveRate.rate };
        }),
        chartMetadata: {
          chartType: "EffectiveHourlyRateProfitability",
          allowedColumns: ['Month', 'HourlyRate', 'HourlyCost', 'Profitability']
        }
      };
  }

  vaNvaSheet(legendToggleVaAndNvaChart, filteredApiDataVaAndNva) {
    if(legendToggleVaAndNvaChart === 'All' || legendToggleVaAndNvaChart === undefined){
      return {
        exportScope: {
          value: 'All',
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: filteredApiDataVaAndNva.filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S'))),
        chartMetadata: {
          chartType: "VaNva",
          allowedColumns: ['Month', 'NvaDuration', 'VaDuration']
        }
      };
    }

    if(legendToggleVaAndNvaChart === 'Nva'){
      return {
        exportScope: {
          value: 'Nva',
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: filteredApiDataVaAndNva.map((x) => {
          x.vaDuration = 'PT0S';
          return x;
        }).filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S'))),
        chartMetadata: {
          chartType: "VaNva",
          allowedColumns: ['Month',  'NvaDuration']
        }
      };
    }

    if(legendToggleVaAndNvaChart === 'Va'){
      return {
        exportScope: {
          value: 'Va',
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: filteredApiDataVaAndNva.map((x) => {
          x.nvaDuration = 'PT0S';
          return x;
        }).filter((x) => ((!x.vaDuration && !x.nvaDuration) || (x.vaDuration && x.vaDuration !== 'PT0S') || (x.nvaDuration && x.nvaDuration !== 'PT0S'))),
        chartMetadata: {
          chartType: "VaNva",
          allowedColumns: ['Month', 'VaDuration']
        }
      };
    }
  }

  processProblemsSheet(dataProcessProblemChart, dataProcessProblemChartProcessProblems) {
    let charDataTable = []; // TOOD: refactor this...
    dataProcessProblemChart && dataProcessProblemChart.map((x)=> {
      x.problems && x.problems.map((y)=>{
        charDataTable.push({
          month: x.date,
          name: y.name,
          count: y.count
        });
      });

    });

    return {
      exportScope: {
        value: 'All',
        processGroup: null,
        processName: null,
        seniorityLevels: null,
        processProblems: dataProcessProblemChartProcessProblems
      },
      data: charDataTable,
      chartMetadata: {
        chartType: "ProcessProblems",
        allowedColumns: ['Month', 'Problem', 'Count']
      }
    };
  }

  employeeRoleSheet(dataSeniorityLevelChart, dataProcessRoles) {
    let charDataTable = []; // TODO: refactor this
    dataSeniorityLevelChart && dataSeniorityLevelChart.map((x)=> {
      x.seniorityLevels && x.seniorityLevels.map((y)=>{
        charDataTable.push({
          month: x.date,
          seniorityLevel: y.seniorityLevel,
          timeSpent: y.timeSpent
        });
      });

    });

    return {
      exportScope: {
        value: 'All',
        processGroup: null,
        processName: null,
        seniorityLevels: dataProcessRoles,
        processProblems: null
      },
      data: charDataTable,
      chartMetadata: {
        chartType: "EmployeeRole",
        allowedColumns:  ['Month', 'SeniorityLevel', 'Time']
      }
    };
  }

  volumeSheet(exportVolSlicerChart, selectedRowVolsSlicer) {
    let charDataTable = [];
    exportVolSlicerChart && exportVolSlicerChart.map((x)=> {
      x.processes.map((y)=>{
        charDataTable.push({
          month: x.date,
          process: y.processName,
          previousMonth: y.prevVolume,
          volume: y.volume,
          averageTimePerUnit: y.avgTimePerUnit
        });
      });

    });

    return {
      exportScope: {
        value: 'All',
        processGroup: null,
        processName: selectedRowVolsSlicer,
        seniorityLevels: null,
        processProblems: null
      },
      data: charDataTable,
      chartMetadata: {
        chartType: "Volume",
        allowedColumns:  ['Month', 'Process',  'PreviousMonth', 'Volume', 'AverageTimePerUnit']
      }
    };
  }

  downloadAllExcel(selClients, selTeams, filteredApiDataPg, filteredApiDataVaAndNva, filteredApiDataProfitability, filteredApiDataProcessProblems, filteredApiDataEmployeeRole, filteredApiVolume, legendToggleGroupChart, legendToggleVaAndNvaChart, selectedProcessGroup, dataProcessProblemChartProcessProblems, dataProcessRoles, dataVolumeProcesses) {
    this.state = "loading";

    const sheets = [this.processGroupSheet(legendToggleGroupChart, filteredApiDataPg),
      this.vaProcessesSheet(filteredApiDataPg, selectedProcessGroup),
      this.nvaProcessesSheet(filteredApiDataPg, selectedProcessGroup),
      this.profitabilitySheet(filteredApiDataProfitability),
      this.vaNvaSheet(legendToggleVaAndNvaChart, filteredApiDataVaAndNva),
      this.processProblemsSheet(filteredApiDataProcessProblems, dataProcessProblemChartProcessProblems),
      this.employeeRoleSheet(filteredApiDataEmployeeRole, dataProcessRoles),
      this.volumeSheet(filteredApiVolume, dataVolumeProcesses)];

    this.Clients.getExportedDataMultipleSheets(
      this.startDate.format("YYYY-MM"), this.endDate.format("YYYY-MM"),
      selClients, selTeams, sheets
    ).then(res => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
        res,
        res.headers("content-type"),
        `klix-360-all-${this.startDate.format("YYYY-MM-DD")}-${this.endDate.format("YYYY-MM-DD")}-${moment().format("HH:mm")}.xlsx`
      );
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  downloadExcel(exportData) {
    const scope = exportData ? exportData.type : 'All';
    const type = scope !== 'All' ? `${scope}-` : '';

    const selClients = this.selectedClients.length ? this.selectedClients : [];
    const selTeams = this.selectedTeamsSelected.length ? this.selectedTeamsSelected : [];

    const legendToggleGroupChart = this.$rootScope.toggleValueProcessGroupChart;
    const legendToggleVaAndNvaChart = this.$rootScope.toggleValueVaAndNvaChart;
    const selectedProcessGroup = this.$rootScope.selectedProcessGroup;
    const dataProcessProblemChartProcessProblems = this.$rootScope.dataProcessProblemChartProcessProblems;
    const dataProcessRoles = this.$rootScope.dataProcessRoles;
    const dataVolumeProcesses = this.$rootScope.selectedRowVolsSlicer;

    const filteredApiDataPg = angular.copy(this.data.valueAddedProcesses) || [];
    const filteredApiDataVaAndNva = angular.copy(this.data.valueAddedByMonth) || [];
    const filteredApiDataProfitability = angular.copy(this.data.effectiveRate) || [];
    const filteredApiDataProcessProblems = angular.copy(this.data.processProblems) || [];
    const filteredApiDataEmployeeRole = angular.copy(this.data.timeBySeniorityLevel) || [];
    const filteredApiVolume = angular.copy(this.data.volumes) || [];

    let sheet = null;

    if (!exportData) {
      return this.downloadAllExcel(selClients,
        selTeams,
        filteredApiDataPg,
        filteredApiDataVaAndNva,
        filteredApiDataProfitability,
        filteredApiDataProcessProblems,
        filteredApiDataEmployeeRole,
        filteredApiVolume,
        legendToggleGroupChart,
        legendToggleVaAndNvaChart,
        selectedProcessGroup,
        dataProcessProblemChartProcessProblems,
        dataProcessRoles,
        dataVolumeProcesses);
    } else if(exportData.type === 'ProcessGroup'){
      sheet = this.processGroupSheet(legendToggleGroupChart, filteredApiDataPg);
    } else if (exportData.type === 'VaProcesses') {
      sheet = this.vaProcessesSheet(filteredApiDataPg, selectedProcessGroup);
    } else if (exportData.type === 'NvaProcesses') {
      sheet = this.nvaProcessesSheet(filteredApiDataPg, selectedProcessGroup);
    } else if (exportData.type === 'Profitability') {
      sheet = this.profitabilitySheet(filteredApiDataProfitability);
    } else if (exportData.type === 'VaNva'){
      sheet = this.vaNvaSheet(legendToggleVaAndNvaChart, filteredApiDataVaAndNva);
    } else if (exportData.type === 'ProcessProblems') {
      sheet = this.processProblemsSheet(filteredApiDataProcessProblems, dataProcessProblemChartProcessProblems);
    } else if (exportData.type === 'EmployeeRole') {
      sheet = this.employeeRoleSheet(filteredApiDataEmployeeRole, dataProcessRoles);
    } else if (exportData.type === 'Volume') {
      sheet = this.volumeSheet(filteredApiVolume, dataVolumeProcesses);
    } else {
      sheet = {
        exportScope: {
          value: null,
          processGroup: null,
          processName: null,
          seniorityLevels: null,
          processProblems: null
        },
        data: [],
        chartMetadata: {
          chartType: null,
          allowedColumns:  []
        }
      };
    }

    this.state = "loading";
    this.Clients.getExportedData(
      sheet.exportScope, this.startDate.format("YYYY-MM"), this.endDate.format("YYYY-MM"),
      sheet.data, selClients, selTeams, sheet.chartMetadata
    ).then(res => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
        res,
        res.headers("content-type"),
        `klix-360-${type.toLowerCase()}${this.startDate.format("YYYY-MM-DD")}-${this.endDate.format("YYYY-MM-DD")}-${moment().format("HH:mm")}.xlsx`
      );
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  filtersChanged(newData) {
    this.state = "loading";
    this.selectedClients = newData.clients;
    this.selectedGroups = newData.groups;
    this.selectedTeams = newData.teams;
    this.selectedTeamsSelected = Object.keys(this.selectedTeams).filter(key => this.selectedTeams[key]);

    const selClients = this.selectedClients.length ? this.selectedClients : [];
    const selTeams = this.selectedTeamsSelected.length ? this.selectedTeamsSelected : [];

    this.refresh360View()
    .then(() => {
      this.Clients.getData(
        this.startDate.format("YYYY-MM"), this.endDate.format("YYYY-MM"),
        selClients, selTeams
      ).then(res => {
        this.data.summaries = res.data.summaries;
        this.data.valueAddedProcesses = res.data.valueAddedProcesses;
        this.data.effectiveRate = res.data.effectiveRates;
        this.data.valueAddedByMonth = res.data.valueAddedByMonth;
        this.data.processProblems = res.data.processProblems;
        this.data.timeBySeniorityLevel = res.data.timeBySeniorityLevel;
        this.data.volumes = res.data.volumes;
        this.monthlyIncomes = res.data.monthlyIncomes;

        if (this.currencyRatio === 1) {
          if(typeof res.data.summaries.effectiveRate.rate === 'undefined'){
            if(res.data.summaries.effectiveRate.noRate === 'NotApplicable')
              this.localCurrency = '';
            if(res.data.summaries.effectiveRate.noRate === 'DivisionByZero')
              this.localCurrency = '';
          } else {
            this.localCurrency = res.data.summaries.effectiveRate.rate.hourlyRate.currency;
            this.currentCurrency = this.localCurrency;
          }
        }

        if (
          this.currencyFromParam
          && this.currencyFromParam === 'EUR'
          && this.localCurrency !== 'EUR'
        ) {
          this.setCurrency(this.currencyFromParam);
          this.currencyFromParam = null;
        }

        this.state = "loaded";
        if (this.currencies && this.currencies[this.localCurrency])
          this.exchangeRate = this.currencies[this.localCurrency];
      }, () => {
        this.state = "error";
      });
    });

  }

  hideShareDlg() {
    this.shareDlgVisible = false;
    this.shareLink = null;
    this.shareDlgData = null;
  }

  currentMonthDiff() {
    if (!this.endDate || !this.startDate) {
      return 0;
    }

    return this.endDate.diff(this.startDate, 'months') + 1;
  }

  processGroupChanged(processGroup) {
    this.selectedProcessGroup = processGroup;
    this.$rootScope.selectedProcessGroup = processGroup;
    this.$scope.$apply();
  }

  refresh360View() {
    this.state = "loading";
    this.data = {};
    this.allTablesCurrencyLocal = false;
    const calls = [
      this.Clients.getFilterData(this.startDate.format("YYYY-MM"), this.endDate.format("YYYY-MM")),
      this.Stats.getSubordinateTeams()
    ];

    if (!this.currencies) {
      this.Clients.getCurrencies()
        .then((res) => {
          if (this.currenciesError)
            this.currenciesError = false;
          
          this.currencies = res.data;
        })
        .catch(() => this.currenciesError = true)
        .finally(() => this.setupCurrencyRate());
    }

    return this.$q.all(calls).then(res => {
        // another quick fix to narrow down number of clients shown in manager's 360

        let clientsWith0TimeAndIncome = res[0].data[1].map((x) => {
          return {
            ...x,
            timeSpent: `PT0S`
          };
        });

        res[0].data = res[0].data[0].filter((c) => {
          return c.teams.find(t => res[1].data.find(tt => tt.id === t.id));
        }).map(c => {
          const teams = c.teams.filter(t => res[1].data.find(tt => tt.id === t.id));
          const secondsSpent = teams.map(t => t.users).flat().reduce(
            function(prev, curr) {
              return prev + moment.duration(curr.timeSpent).asMilliseconds();
            }, 0) / 1000;

          return {
            ...c,
            teams: teams,
            timeSpent: `PT${secondsSpent}S`
          };
        });

        // quick fix for data showing in TL
        if (this.isLeader) {
          res[0].data = res[0].data.filter(c => {
            return c.teams.find(t => t.id === this.leaderTeamId);
          }).map(c => {
            const leadersTeam = c.teams.find(t => t.id === this.leaderTeamId);
            const secondsSpent = leadersTeam.users.reduce(
              function(prev, curr) {
                return prev + moment.duration(curr.timeSpent).asMilliseconds();
              }, 0) / 1000;

            return {
              ...c,
              teams: [leadersTeam],
              timeSpent: `PT${secondsSpent}S`
            };
          });
        }

        res[0].data = res[0].data.concat(clientsWith0TimeAndIncome);

        this.filtersData = {
          groups: {title: 'Client groups', data: []},
          clients: {title: 'Clients', data: []},
          teams: {title: 'Teams', data: []},
          employees: {title: 'Employees', data: []},
          nestedData: res[0].data
        };

        this.mapActiveClients(res[0].data);

        const groupExists = this.type === 'group' && this.filtersData.groups.data.filter(g => g.name.toLowerCase() === this.clientId.toLowerCase()).length;
        const clientExists = this.type === 'client' && this.filtersData.clients.data.filter(c => c.name.toLowerCase() === this.clientId.toLowerCase()).length;
        this.hasId = groupExists || clientExists;
      },
      () => this.state = "error"
    ).then(res => {
        if (!res) {
          return;
        }

        this.data.summaries = res.data.summaries;
        this.data.valueAddedProcesses = res.data.valueAddedProcesses;
        this.data.effectiveRate = res.data.effectiveRates;
        this.data.valueAddedByMonth = res.data.valueAddedByMonth;
        this.data.processProblems = res.data.processProblems;
        this.data.timeBySeniorityLevel = res.data.timeBySeniorityLevel;
        this.data.volumes = res.data.volumes;
        if (this.currencyRatio === 1) {
          this.localCurrency = res.data.summaries.effectiveRate.rate.hourlyRate.currency;
          this.currentCurrency = this.localCurrency;
        }
      },
      () => this.state = "error"
    ).then(() => {
      this.type = null;
      this.clientId = null;
      this.hasId = false;
    }, () => this.state = "error");
  }

  mapActiveClients(clients) {
    clients.forEach(client => {
      if (!client.clientGroup) {
        client.clientGroup = {id: 'OTHERS', name: this.$translate.instant('VIEW360.OTHERS')};
      }
    });

    clients.forEach(client => {
      if (client.name.toLowerCase() === 'internal') {
        return;
      }

      if (this.leaderTeamId) {
        const tlTeams = client.teams.filter(t => t.id === this.leaderTeamId);
        if (!tlTeams.length) {
          return;
        }
      }

      const teams = client.teams ? this.leaderTeamId ? client.teams.filter(t => t.id === this.leaderTeamId) : client.teams : [];
      teams.forEach(team => {
        if (this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' && team.name.toLowerCase() === 'team iterators') {
          return;
        }

        const users = team.users ? team.users : [];
        const teamUsers = [];

        users.forEach(user => {
          const empIdx = this.filtersData.employees.data.findIndex(x => x.id === user.id);
          const teamIdx = teamUsers.findIndex(x => x.id === user.id);
          if (teamIdx < 0) {
            teamUsers.push({
              id: user.id,
              value: moment.duration(user.timeSpent).asMilliseconds(),
              durationClients: [{client, value: moment.duration(user.timeSpent).asMilliseconds()}]
            });
          } else {
            teamUsers[teamIdx].value += moment.duration(user.timeSpent).asMilliseconds();
            teamUsers[teamIdx].durationClients.push({client, value: moment.duration(user.timeSpent).asMilliseconds()});
          }

          if (empIdx < 0) {
            this.filtersData.employees.data.push({
              id: user.id,
              name: user.fullName,
              parentIds: [team.id],
              parentInTeamValue: {[team.id]: moment.duration(user.timeSpent).asMilliseconds()},
              value: moment.duration(user.timeSpent).asMilliseconds(),
              durationClients: [{client: client, team: team, value: moment.duration(user.timeSpent).asMilliseconds()}]
            });
          } else {
            if (!this.filtersData.employees.data[empIdx].parentInTeamValue[team.id]) {
              this.filtersData.employees.data[empIdx].parentInTeamValue[team.id] = 0;
            }
            if (this.filtersData.employees.data[empIdx].parentIds.indexOf(team.id) < 0) {
              this.filtersData.employees.data[empIdx].parentIds.push(team.id);
            }
            this.filtersData.employees.data[empIdx].parentInTeamValue[team.id] += moment.duration(user.timeSpent).asMilliseconds();
            this.filtersData.employees.data[empIdx].value += moment.duration(user.timeSpent).asMilliseconds();
            this.filtersData.employees.data[empIdx].durationClients.push({client: client, team: team, value: moment.duration(user.timeSpent).asMilliseconds()});
          }
        });
        const teamIdx = this.filtersData.teams.data.findIndex(t => t.id === team.id);
        if (teamIdx < 0) {
          const teamForStatus = this.selectedTeams[team.id];
          this.filtersData.teams.data.push({
            id: team.id,
            name: team.name,
            value: teamUsers.map(tu => tu.value).reduce((a, b) => a + b, 0),
            durationClients: teamUsers.map(x => x.durationClients).flat(),
            preSelected: this.allTeams || (teamForStatus !== null && teamForStatus !== undefined ? teamForStatus : true)
          });
        } else {
          this.filtersData.teams.data[teamIdx].value += teamUsers.map(tu => tu.value).reduce((a, b) => a + b, 0);
          this.filtersData.teams.data[teamIdx].durationClients = [
            ...this.filtersData.teams.data[teamIdx].durationClients,
            ...teamUsers.map(x => x.durationClients).flat()
          ];
          if (this.allTeams)
            this.filtersData.teams.data[teamIdx].preSelected = true;
        }
      });
      
      const clientTimeSpent = moment.duration(
        client.teams
          .filter(t => Object.keys(this.selectedTeams).filter(k => this.selectedTeams[k]).includes(t.id))
          .reduce((prev, curr) => {
            if (!curr.users || curr.users.length === 0) return prev;
            curr.users.forEach(u => prev = prev + moment.duration(u.timeSpent || 0).asMilliseconds());
            return prev;
          }, 0)
      );
      const clientLower = client.name.toLowerCase();
      const preSelected =
        this.initialClientNameFromParam === client.name
        || (client.clientGroup && this.selectedGroups.indexOf(client.clientGroup.id) > -1 )
        || this.selectedClients.indexOf(client.id) > -1;

      if (this.initialClientNameFromParam)
          this.initialClientNameFromParam = null;

      const external =
        (client.clientGroup && this.type === 'group' && client.clientGroup.name.toLowerCase() === this.clientId.toLowerCase())
        || (this.type === 'client' && clientLower === this.clientId.toLowerCase());
      const newClient = {
        id: client.id,
        name: client.name,
        value: clientTimeSpent,
        external: external,
        preSelected: preSelected
      };
      
      if (client.additionalInfo) {
        newClient.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;
      }

      if (client.clientGroup) {
        const group = client.clientGroup;
        newClient.parentId = group.id;
        const groupIdx = this.filtersData.groups.data.findIndex(g => g.id === group.id);

        if (groupIdx < 0) {
          this.filtersData.groups.data.push({
            id: group.id,
            name: group.name,
            parentId: null,
            value: clientTimeSpent,
            external: this.type === 'group' && group.name.toLowerCase() === this.clientId.toLowerCase(),
            preSelected: this.selectedGroups.indexOf(group.id) > -1,
            clients: [newClient]
          });
        } else {
          this.filtersData.groups.data[groupIdx].value += clientTimeSpent;
          this.filtersData.groups.data[groupIdx].clients.push(newClient);
        }
      }
    });

    this.filtersData.groups.data.forEach(group => {
      group.clients = group.clients.sort((a, b) => {
        return b.value - a.value;
      });
    });

    this.allTeams = null;
  }

  showShareDlg(shareData) {
    this.shareDlgVisible = true;
    if (!shareData || !shareData.type) {
      return;
    }

    let dataToPush;
    let clone;
    switch (shareData.type) {
      case 'all':
        dataToPush = {
          vaAddedProcesses: this.data.valueAddedProcesses.map(d => ({
            name: d.name,
            vaDuration: d.vaDuration,
            processGroupName: d.processGroupName
          })),
          nvaAddedProcesses: this.data.valueAddedProcesses.map(d => ({
            name: d.name,
            nvaDuration: d.nvaDuration,
            processGroupName: d.processGroupName
          })),
          processGroup: this.data.valueAddedProcesses,
          effectiveRates: this.data.effectiveRate,
          valueAddedByMonth: this.data.valueAddedByMonth,
          processProblems: this.data.processProblems,
          timeBySeniorityLevel: this.data.timeBySeniorityLevel,
          volumes: this.data.volumes,
          summaries: this.data.summaries
        };
        break;
      case 'va_processes':
        dataToPush = this.data.valueAddedProcesses.map(d => ({name: d.name, vaDuration: d.vaDuration}));
        break;
      case 'nva_processes':
        dataToPush = this.data.valueAddedProcesses.map(d => ({name: d.name, nvaDuration: d.nvaDuration}));
        break;
      case 'prof_and_hour_rate':
        dataToPush = this.data.effectiveRate;
        break;
      case 'va_and_nva':
        dataToPush = this.data.valueAddedByMonth;
        this.$rootScope.exportProcessGroupVaAndNva = angular.copy(dataToPush);
        break;
      case 'process_group':
        dataToPush = this.data.valueAddedProcesses;
        break;
      case 'process_problems':
        dataToPush = this.data.processProblems;
        break;
      case 'employee_role':
        dataToPush = this.data.timeBySeniorityLevel;
        break;
      case 'vol_slicer_table':
        dataToPush = {
          vaAddedProcesses: this.data.valueAddedProcesses.map(d => ({name: d.name, vaDuration: d.vaDuration})),
          volumes: this.data.volumes
        };
        this.$rootScope.dataVolSlicerChart = dataToPush;
        break;
      case 'vol_slicer_hours':
      case 'vol_slicer_volume':
        clone = {...shareData.data};
        clone.selectedProcesses = shareData.selected;
        dataToPush = clone;
        this.$rootScope.dataVolSlicerHoursvolumeChart = dataToPush;
        break;
    }

    const allClients = this.filtersData.groups.data.flatMap(g => g.clients);
    const selectedClientsRich = allClients.filter(c => this.selectedClients.findIndex(sc => sc === c.id) >= 0).sort((a, b) => b.value - a.value);
    const selectedTeamsRich = this.filtersData.teams.data.filter(t => this.selectedTeamsSelected.findIndex(st => st === t.id) >= 0).filter(t => t.value > 0).sort((a, b) => b.value - a.value);

    this.shareDlgData = {
      type: shareData.type,
      currency: this.currentCurrency,
      currencyRatio: this.currencyRatio,
      chartData: dataToPush,
      endDate: this.endDate.format("YYYY-MM"),
      startDate: this.startDate.format("YYYY-MM"),
      selectedClients: this.selectedClients,
      selectedClientsRich: selectedClientsRich,
      selectedTeamsSelected: this.selectedTeamsSelected,
      selectedTeamsRich: selectedTeamsRich,
      hasAllClientsForGivenSpan: allClients.length !== 1 && selectedClientsRich.length === allClients.length,
      hasAllTeamsForGivenSpan: this.filtersData.teams.data.length !== 1 && selectedTeamsRich.length === this.filtersData.teams.data.length
    };

    this.$scope.exportDataPush = dataToPush;
    this.$rootScope.shareDataChart = this.shareDlgData;
    this.shareDlgVisible = true;
  }

  setupCurrencyRate(){
    if(this.$rootScope.setupRate){
      this.currencyRatio = this.currentCurrency === 'EUR' && this.localCurrency !== 'EUR' ? 1/this.$rootScope.setupRate.rate : 1;
      this.localToEurRatio = (1 / this.$rootScope.setupRate.rate);
    } else {
      this.currencyRatio = this.currentCurrency === 'EUR' && this.localCurrency !== 'EUR' ? this.localToEurRatio : 1;
    }
  }

  setCurrency(currency) {
    this.currentCurrency = currency;
    this.currencyRatio = currency === 'EUR' && this.localCurrency !== 'EUR' ? this.currencies[this.localCurrency] : 1;
    if(this.$rootScope.setupRate) {
      this.localToEurRatio = (1 / this.$rootScope.setupRate.rate);
    } else{
      this.localToEurRatio = (1 / this.currencies[this.localCurrency]);
    }
  }

  storeDateRange(start, end) {
    if (this.isLeader) {
      localStorage.setItem('roedl-tl-date-pv', start + "-" + end);
    } else {
      localStorage.setItem('roedl-m-date-pv', `${start}-${end}`);
    }
  }

  updateDateRange(refreshView) {
    const start = this.dateStartYear + "-" + this.dateStartMonth;
    const end = this.dateEndYear + "-" + this.dateEndMonth;

    this.startDate = moment(start, "YYYY-MM");
    this.endDate = moment(end, "YYYY-MM");

    if (this.endDate.unix() < this.startDate.unix()) {
      this.dateEndMonth = this.startDate.format("MM");
      this.dateEndYear = this.startDate.format("YYYY");
      const start = this.dateStartYear + "-" + this.dateStartMonth;
      const end = this.dateEndYear + "-" + this.dateEndMonth;

      this.startDate = moment(start, "YYYY-MM");
      this.endDate = moment(end, "YYYY-MM");
    }
    this.storeDateRange(start, end);
    if (refreshView) {
      this.refresh360View();
    }
  }
}
